import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { tap } from 'rxjs/operators';

import * as HelpStoreActions from './help-store.actions';
import { Store } from '@ngrx/store';
import { ContentService } from 'src/app/shared/services/content.service';

@Injectable()
export class HelpStoreEffects {
    loadHelpDetails$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(HelpStoreActions.loadHelpDetails),
                tap((data) => {
                    this.contentService
                        .getHelpDetails(data.id)
                        .subscribe((data) => {
                            this.store.dispatch(
                                HelpStoreActions.loadHelpDetailsSuccess({
                                    data: data,
                                })
                            );
                        });
                })
            );
        },
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        private store: Store,
        private contentService: ContentService
    ) {}
}
